// PanierContext.js
import { createContext, useContext, useState } from "react";

const PanierContext = createContext();

export const PanierProvider = ({ children }) => {
  const [panier, setPanier] = useState(
    JSON.parse(localStorage.getItem("panier")) || []
  );

  const updatePanier = (newPanier) => {
    localStorage.setItem("panier", JSON.stringify(newPanier));
    setPanier(newPanier);
  };

  return (
    <PanierContext.Provider value={{ panier, updatePanier }}>
      {children}
    </PanierContext.Provider>
  );
};

export const usePanier = () => useContext(PanierContext);
